import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import AuthShell from "@/components/AuthShell";
import api, { formatApiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError(""); setMsg("");
    try {
      await api.post("/auth/reset-password", { token, password });
      setMsg("Password updated! Redirecting you to sign in…");
      setTimeout(() => navigate("/signin"), 1600);
    } catch (err) { setError(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Set a new password" subtitle="Choose a new password for your account."
      footer={<>Remembered it? <Link to="/signin" className="text-teal font-semibold">Sign in</Link></>}>
      {!token ? (
        <p className="text-red-500">This reset link is invalid or incomplete.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <div>
            <label className="block text-sm font-semibold text-plum mb-1.5">New password</label>
            <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password"
              className="w-full rounded-2xl border-2 border-rose/50 bg-white px-4 py-3 outline-none focus:border-teal transition-colors" />
          </div>
          {error && <p className="text-sm text-red-500">{error}</p>}
          {msg && <p className="text-sm text-teal">{msg}</p>}
          <button type="submit" disabled={loading} data-testid="reset-submit"
            className="w-full rounded-full bg-teal px-6 py-3.5 font-semibold text-white hover:bg-teal-dark transition-colors disabled:opacity-60">
            {loading ? "Updating…" : "Update password"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
